import React, { Component } from 'react';
import { isBrowser } from "react-device-detect";
import LargeHeading from "../../components/LargeHeading";
import ProximitySensors from "../../components/ProximitySensors";
import animations from "./animations";
import Scroll from "../../components/Scroll";

class Home extends Component {

    constructor(props) {
        super(props);

        this.state = {
            tl: null
        };
    }

    componentDidMount() {
        this.initialiseAnimations(0);
        this.merged = false;
        this.positions = animations.getSpanPositions(this.homeHeading);
        animations.animateOnScroll(this.mergeHeadings.bind(this), this.unMergeHeadings.bind(this));

        if (isBrowser) {
			setTimeout(() => this.mergeHeadings(), 500);
			setTimeout(() => this.unMergeHeadings(), 2600);
		}
    }

    handleProximitySensor(level) {
        if (!this.merged && this.state.tl) {
            this.state.tl.clear();
            this.initialiseAnimations(level);
        }
    }

    handleHeadingClick() {
    	this.merged ? this.unMergeHeadings() : this.mergeHeadings();
    }

    mergeHeadings() {
		animations.mergeHeadings(this.homeHeading, this.state.tl);
		this.merged = true;
	}

	unMergeHeadings() {
		let tl = animations.unMergeHeadings(this.homeHeading, this.state.tl, this.positions);
		this.setTl(tl);
		this.merged = false;
	}

    initialiseAnimations(level) {
		this.props.getPauseAnimation(this.pauseAnimation.bind(this));
		this.props.getMergeAnimation(this.mergeHeadings.bind(this));
		this.props.getUnMergeAnimation(this.unMergeHeadings.bind(this));
		if (!this.merged) {
			let tl = animations.initialiseShake(this.container, level);
			this.setTl(tl);
		}
    }

    pauseAnimation() {
		this.state.tl.clear();
	}
    
    setTl(tl) {
        this.setState({tl: tl});
    }

    render() {
        return (
            <section className="home" id="home" ref={el => this.container = el}>
                <LargeHeading title="Josh Warner" ref={el => this.homeHeading = el} className="heading is-home">
                    <div className="sub-copy">
						Senior Full-Stack Engineer<span className="d-lg-none"><br /></span><span className="d-none d-lg-inline">&nbsp;|&nbsp;</span>Head of Engineering<span className="d-lg-none"><br /></span><span className="d-none d-lg-inline">&nbsp;|&nbsp;</span>I also love banana bread <span className="emoji" role="img" aria-label="Yummy">😋</span>
                    </div>
                </LargeHeading>
                <ProximitySensors handleProximitySensor={this.handleProximitySensor.bind(this)} handleHeadingClick={this.handleHeadingClick.bind(this)} />
                <Scroll />
            </section>
        );
    }

}

export default Home;


// WEBPACK FOOTER //
// ./src/js/views/Home/Home.js